import React, { useState, useEffect } from "react";

const MemberInviteModal = ({ isOpen, onClose, onInvite }) => {
  const [userEmail, setUserEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  // Simple email regex for basic validation
  const emailRegex = /\S+@\S+\.\S+/;

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setUserEmail(email);
    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address.");
    } else {
      setEmailError("");
    }
  };

  const handleInviteClick = () => {
    if (emailRegex.test(userEmail)) {
      onInvite(userEmail);
      onClose(); // Close modal after inviting
    }
  };

  // Clear input and errors when modal is closed or opened
  useEffect(() => {
    setUserEmail("");
    setEmailError("");
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
      <div className="relative p-5 border w-full max-w-md shadow-lg rounded-md bg-white">
        <div className="text-center">
          <h3 className="text-lg leading-6 font-medium text-dark-grey">
            Invite a Member
          </h3>
          <div className="mt-4">
            <input
              type="email"
              value={userEmail}
              onChange={handleEmailChange}
              className="input w-full max-w-xs"
              placeholder="Enter user's email"
            />
            {emailError && (
              <p className="text-red-500 text-xs mt-2">{emailError}</p>
            )}
          </div>
          <div className="mt-6 flex justify-center gap-4">
            <button
              onClick={handleInviteClick}
              className="bg-deep-red hover:bg-bright-red text-white font-bold py-2 px-6 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bright-red transition duration-150 ease-in-out"
            >
              Invite
            </button>
            <button
              onClick={onClose}
              className="bg-medium-grey hover:bg-dark-grey text-white font-bold py-2 px-6 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dark-grey transition duration-150 ease-in-out"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberInviteModal;
